import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tagesbericht-nu-workspace',
  templateUrl: './tagesbericht-nu-workspace.component.html',
  styleUrls: ['./tagesbericht-nu-workspace.component.scss']
})
export class TagesberichtNuWorkspaceComponent {}
